/* eslint-disable */
import { GTM_CONTAINER_ID, GTM_EXTRA_PARAMS } from '../../settings';

const gtmScript = (): void => {
  // @ts-expect-error
  !((e, t, _, n, a) => {
    (e[n] = e[n] || []), e[n].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    let w = t.getElementsByTagName(_)[0],
      o = t.createElement(_) as HTMLScriptElement;
    (o.async = !0),
      (o.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}${GTM_EXTRA_PARAMS}`),
      // @ts-expect-error
      w.parentNode.insertBefore(o, w);
  })(window, document, 'script', 'dataLayer');
};

export default gtmScript;
